<template>
  <div class="sidebar-left">
    <div class="sidebar">

      <!-- Sidebar Content -->
      <div
        class="sidebar-content card app-tour-services-left-sidebar"
        :class="{'show': mqShallShowLeftSidebar}"
      >

        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search app-tour-services-search-area">
          <div class="d-flex align-items-center w-100">
            <!-- Search -->
            <b-input-group class="input-group-merge w-100 round">
              <b-input-group-prepend is-text>
                <feather-icon
                  icon="SearchIcon"
                  class="text-muted"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('shared.search')"
              />
            </b-input-group>
          </div>
        </div>

        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >

          <b-button
            variant="flat-primary"
            class="mx-2 mt-1 app-tour-services-add-button"
            @click="$emit('add-new-service')"
          >
            <feather-icon icon="PlusIcon" />
            {{ $t('services.add-new') }}
          </b-button>

          <!-- Chats Title -->
          <h4 class="chat-list-title mt-1">
            {{ $t('services.title') }}
            <b-badge
              v-show="filteredServices.length > 0"
              pill
              variant="light-primary"
              size="xs"
            >
              {{ filteredServices.length }}
            </b-badge>
            <b-button
              v-b-tooltip.hover
              :variant="showArchived ? 'primary' : 'flat-secondary'"
              class="btn-icon mt-n25 float-right app-tour-services-toggle-archived-button"
              size="sm"
              :title="showArchived ? $t('shared.archived.hide') : $t('shared.archived.show')"
              @click="refetchData()"
            >
              <feather-icon icon="ArchiveIcon" />
            </b-button>
          </h4>

          <!-- Chats -->
          <ul class="chat-users-list chat-list media-list app-tour-services-list app-tour-services-list-area">
            <service-list-item
              v-for="service in filteredServices"
              :key="service.id"
              :service="service"
              tag="li"
              :class="{'active': activeServiceId === service.id, 'archived': service.archived}"
              @click="$emit('open-service-view', service.id)"
            />
          </ul>

        </vue-perfect-scrollbar>
      </div>

    </div>
  </div>
</template>

<script>
import {
  BBadge, BButton, BFormInput, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { computed, ref } from '@vue/composition-api'
import ServiceListItem from '@/views/organization/services/ServiceListItem'
import store from '@/store'

export default {
  components: {
    BBadge,
    ServiceListItem,

    // BSV
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,

    // 3rd party
    VuePerfectScrollbar,

  },
  props: {
    services: {
      type: Array,
      required: true,
    },
    activeServiceId: {
      type: Number,
      default: null,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }
    const showArchived = computed(() => store.getters['service/showArchived'])
    const disableShowArchived = ref(false)

    // Search Query
    const searchQuery = ref('')

    const searchFilterFunction = service => {
      if (searchQuery.value.length === 0) {
        return true
      }

      let result = false
      searchQuery.value.split(' ').forEach(value => {
        if (!value) return false
        result = service.name.toLowerCase().includes(value.toLowerCase())
            || (service.shortDescription && service.shortDescription.toLowerCase().includes(value.toLowerCase()))

        return result
      })
      return result
    }

    const filteredServices = computed(() => props.services.filter(searchFilterFunction))

    const refetchData = () => {
      if (disableShowArchived.value) {
        return
      }
      disableShowArchived.value = true
      store.dispatch(
        'service/fetchServices',
        { ignoreArchived: !showArchived.value ? 0 : 1 },
      )
        .finally(() => {
          disableShowArchived.value = false
        })
      store.commit('service/SET_SHOW_ARCHIVED', !showArchived.value)
    }

    return {
      // Search Query
      searchQuery,
      filteredServices,
      showArchived,
      disableShowArchived,
      refetchData,

      // UI
      perfectScrollbarSettings,
    }
  },
}
</script>
